angular.module('tf.controllers')

    .filter('uiType', [function(){
        return function(controls, types){
            return _.filter(controls, function(control){
                return control.ui && _.includes(types, control.ui.type);
            });
        };
    }])

    .filter('notHidden', [function(){
        return function(templates){
            return _.filter(templates, function(template){
                return !template.hide;
            });
        };
    }])

    .controller('ProjectSettingsController', ['$scope', '$state', '$stateParams', 'HttpService', 'project', 'UrlEncodingService','RenderService','FarmerService','ConfirmExitService','HeaderService','$rootScope','ProjectService','MixpanelService','$timeout','ThumbnailSequence','NotificationService',
        function ($scope, $state, $stateParams, HttpService, project, UrlEncodingService, RenderService, FarmerService, ConfirmExitService, HeaderService, $rootScope, ProjectService, MixpanelService, $timeout, ThumbnailSequence, NotificationService) {
            $scope.project = project;
            $scope.path = $stateParams.path;
            $scope.settingsChanged = false;

            $scope.saveSettings = function() {
                HttpService.post("farmer/" + project.fid + "/project/settings",
                    {
                        id : project.id,
                        project : JSON.stringify(project.clean())
                    }
                ).then(
                    function (data) {
                        //success
                        $scope.$close();
                        $timeout(function () {
                            $rootScope.$broadcast('tf-reset-project');
                        }, 250);
                    },
                    function (err) {
                        //fail
                    });
            };

            $scope.insertSyntax = function(inputSelector,syntax){
                var input = $(inputSelector);
                input.focus();
                var caretPosStart = input[0].selectionStart;
                var caretPosEnd = input[0].selectionEnd;

                if(caretPosStart !== caretPosEnd){
                    input.val(input.val().substring(0, caretPosStart) + input.val().substring(caretPosEnd) );
                }

                var text = input.val();
                input.val(text.substring(0, caretPosStart) + syntax + text.substring(caretPosStart) );
                input[0].selectionStart = caretPosStart + syntax.length;
                input[0].selectionEnd = caretPosStart + syntax.length;
                angular.element(input).triggerHandler('input');
            };

            var unwatch = $scope.$watch('project', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatch();
                    $scope.settingsChanged = true;
                }
            }, true);

            $scope.cancel = function(){
                if($scope.settingsChanged) {
                    event.preventDefault();
                    NotificationService.popup('confirm-settings-exit', {
                        onLeave: function(){
                            $timeout(function(){$scope.$close();},200);
                        }
                    },{backdrop : false});
                } else {
                    $scope.$close();
                }
            };


        }]);